import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Show the first tab by default if none are active
    if (!this.tabTargets.find(tab => tab.classList.contains('border-indigo-500'))) {
      this.activate(this.tabTargets[0])
    }
  }

  switch(event) {
    const clickedTab = event.currentTarget
    this.activate(clickedTab)
  }

  activate(tab) {
    // Update tab styling
    this.tabTargets.forEach(t => {
      t.classList.remove('border-indigo-500', 'text-indigo-600')
      t.classList.add('border-transparent', 'text-gray-500')
    })
    tab.classList.remove('border-transparent', 'text-gray-500')
    tab.classList.add('border-indigo-500', 'text-indigo-600')

    // Show corresponding panel
    const countryId = tab.dataset.countryId
    this.panelTargets.forEach(panel => panel.classList.add('hidden'))
    this.panelTargets.find(panel => panel.id === `country-${countryId}`).classList.remove('hidden')
  }
} 